import { addLocaleData } from "react-intl";
import th from "react-intl/locale-data/th";
import es from "react-intl/locale-data/es";

addLocaleData([...th, ...es]);
